/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/

export enum EventAction {
  clickEcommerceProduct = "CLICK_ECOMMERCE_PRODUCT",
  clickEcommerceStorefrontCollection = "CLICK_ECOMMERCE_STOREFRONT_COLLECTION",
  clickEcommerceLocations = "CLICK_ECOMMERCE_LOCATIONS",
  // Products homepage (SC-SF1–SF13)
  pageView = "PAGEVIEW",
  clickCreateNewItem = "CLICK_CREATE_NEW_ITEM",
  clickBulkFunctionsOption = "CLICK_BULK_FUNCTIONS_OPTION",
  clickEditItem = "CLICK_EDIT_ITEM",
  clickEditStockInline = "CLICK_EDIT_STOCK_INLINE",
  selectItemsPerPage = "SELECT_ITEMS_PER_PAGE",
  // Product bulk upload (SC-P1–P4)
  clickDownloadTemplate = "CLICK_DOWNLOAD_TEMPLATE",
  clickCancelDownloadTemplate = "CLICK_CANCEL_DOWNLOAD_TEMPLATE",
  clickUploadFile = "CLICK_UPLOAD_FILE",
  clickBack = "CLICK_BACK",
  submitUploadZip = "SUBMIT_UPLOAD_ZIP",
  clickDownloadActivityFile = "CLICK_DOWNLOAD_ACTIVITY_FILE",
  // Product item creation/edit (SC-IC1–IC17)
  clickExit = "CLICK_EXIT",
  clickNext = "CLICK_NEXT",
  submitSaveItem = "SUBMIT_SAVE_ITEM",
  clickAddProductImage = "CLICK_ADD_PRODUCT_IMAGE",
  clickRemoveProductImage = "CLICK_REMOVE_PRODUCT_IMAGE",
  clickAddProductVideo = "CLICK_ADD_PRODUCT_VIDEO",
  clickRemoveProductVideo = "CLICK_REMOVE_PRODUCT_VIDEO",
  selectCategory = "SELECT_CATEGORY",
  clickToggleVariation = "CLICK_TOGGLE_VARIATION",
  clickToggleDiffDimensionsForVariations = "CLICK_TOGGLE_DIFF_DIMENSIONS_FOR_VARIATIONS",
  clickAddVariation = "CLICK_ADD_VARIATION",
  selectVariationType = "SELECT_VARIATION_TYPE",
  clickRemoveVariation = "CLICK_REMOVE_VARIATION",
  clickAddOption = "CLICK_ADD_OPTION",
  clickRemoveOption = "CLICK_REMOVE_OPTION",
  // Multi-store locations – Products page (SC-MSL-P1–P4)
  selectStoreLocationFilter = "SELECT_STORE_LOCATION_FILTER",
  validateStoreIDQueryParam = "VALIDATE_STORE_ID_QUERY_PARAM",
  clickEditStock = "CLICK_EDIT_STOCK",
  clickConfirm = "CLICK_CONFIRM",
  // Storefront collections homepage (SC-SG1–SG7)
  clickCreateCollection = "CLICK_CREATE_COLLECTION",
  clickExpandCollection = "CLICK_EXPAND_COLLECTION",
  clickAddProductsInline = "CLICK_ADD_PRODUCTS_INLINE",
  clickToggleCollectionVisibility = "CLICK_TOGGLE_COLLECTION_VISIBILITY",
  clickThreeDotMenu = "CLICK_THREE_DOT_MENU",
  selectCollectionAction = "SELECT_COLLECTION_ACTION",
  // Collection create/edit (SC-SG8–SG11)
  clickAddProduct = "CLICK_ADD_PRODUCT",
  clickCancel = "CLICK_CANCEL",
  submitConfirmCollection = "SUBMIT_CONFIRM_COLLECTION",
  clickRemoveProduct = "CLICK_REMOVE_PRODUCT",
  // Add products modal (SC-SG12–SG19, SG25; SG14/SG17 not wired — unsupported)
  clickSelectAllProduct = "CLICK_SELECT_ALL_PRODUCT",
  clickSelectProduct = "CLICK_SELECT_PRODUCT",
  submitAddProducts = "SUBMIT_ADD_PRODUCTS",
  clickCancelAddProducts = "CLICK_CANCEL_ADD_PRODUCTS",
  // Delete collection (SC-SG20–SG22)
  submitDeleteCollection = "SUBMIT_DELETE_COLLECTION",
  clickCancelDeleteCollection = "CLICK_CANCEL_DELETE_COLLECTION",
  // Reorder collections (SC-SG23–SG24)
  submitReorderCollections = "SUBMIT_REORDER_COLLECTIONS",
  // Multi-Store Locations (SC-MSL2–MSL4)
  clickExpandLocation = "CLICK_EXPAND_LOCATION",
  clickEditLocation = "CLICK_EDIT_LOCATION",
  // PMF feedback prompt
  feedbackPromptShown = "FEEDBACK_PROMPT_SHOWN",
  feedbackPromptDismissed = "FEEDBACK_PROMPT_DISMISSED",
  feedbackSubmitted = "FEEDBACK_SUBMITTED",
  qualifyingEventCompleted = "QUALIFYING_EVENT_COMPLETED",
}

export enum EventCategory {
  sidebarNavigation = "SIDE_BAR_NAVIGATION",
  productsHomepage = "PRODUCTS_HOMEPAGE",
  productsBulkUploadPage = "PRODUCTS_BULK_UPLOAD_PAGE",
  productsEditItemPage = "PRODUCTS_EDIT_ITEM_PAGE",
  storefrontCollectionsHomepage = "STOREFRONT_COLLECTIONS_HOMEPAGE",
  storefrontCollectionsEditPage = "STOREFRONT_COLLECTIONS_EDIT_PAGE",
  storefrontCollectionsAddProduct = "STOREFRONT_COLLECTIONS_ADD_PRODUCT",
  storefrontCollectionsEdit = "STOREFRONT_COLLECTIONS_EDIT",
  storefrontCollectionsDeletePage = "STOREFRONT_COLLECTIONS_DELETE_PAGE",
  storefrontCollectionsTab = "STOREFRONT_COLLECTIONS_TAB",
  storefrontCollectionsReorderPage = "STOREFRONT_COLLECTIONS_REORDER_PAGE",
  locationsHomepage = "LOCATIONS_HOMEPAGE",
  // Multi-store locations – stock modal (SC-MSL-P3–P4)
  productsEditItemStockModal = "PRODUCTS_EDIT_ITEM_STOCK_MODAL",
  pmfFeedback = "PMF_FEEDBACK",
}

export enum BulkFunctionOption {
  addItemsInBulk = "ADD_ITEMS_IN_BULK",
  bulkUpdateStockCount = "BULK_UPDATE_STOCK_COUNT",
}

export enum StoreIDParamValidationOutcome {
  applied = "APPLIED",
  invalidFormat = "INVALID_FORMAT",
  reservedStoreID = "RESERVED_STORE_ID",
  rejectedByLookup = "REJECTED_BY_LOOKUP",
  ignoredSingleStore = "IGNORED_SINGLE_STORE",
}

export enum StoreIDParamValidationErrorMessage {
  lookupFailed = "LOOKUP_FAILED",
  responseStoreIDMismatch = "RESPONSE_STORE_ID_MISMATCH",
  missingResponseStoreID = "MISSING",
}

export enum ItemIntent {
  addItem = "ADD_ITEM",
  editItem = "EDIT_ITEM",
  updateStockCount = "UPDATE_STOCK_COUNT",
}

export enum ProductEditItemStep {
  basic = "1_BASIC",
  shipping = "2_SHIPPING",
  variations = "3_VARIATIONS",
  specifications = "4_SPECS",
}

export enum CollectionIntent {
  addCollection = "ADD_COLLECTION",
  editCollection = "EDIT_COLLECTION",
}

export enum CollectionAction {
  edit = "EDIT",
  reorder = "REORDER",
  delete = "DELETE",
}

export enum AddProductEntryPoint {
  storefrontCollectionsCreatePage = "STOREFRONT_COLLECTIONS_CREATE_PAGE",
  storefrontCollectionsEditPage = "STOREFRONT_COLLECTIONS_EDIT_PAGE",
  storefrontCollectionsHomepage = "STOREFRONT_COLLECTIONS_HOMEPAGE",
}

export enum AddProductsSubmitStatus {
  success = "SUCCESS",
  failure = "FAILURE",
}

/**
 * `STATUS` on the product wizard's CLICK_NEXT event. The Continue button stays
 * enabled on an incomplete step so the click can report what is missing, so the
 * event fires for every click and this label is what separates a click that
 * advanced from one the step's own rules turned back.
 */
export enum ContinueStepStatus {
  success = "SUCCESS",
  validationError = "VALIDATION_ERROR",
}
